import { render } from "./PhoneNumberDialog.vue?vue&type=template&id=b58d8766&scoped=true"
import script from "./PhoneNumberDialog.vue?vue&type=script&lang=js"
export * from "./PhoneNumberDialog.vue?vue&type=script&lang=js"

import "./PhoneNumberDialog.vue?vue&type=style&index=0&id=b58d8766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b58d8766"]])

export default __exports__